module.exports = "/assets/thermokon-wrf06.png";